/* HVAC-069 */

(function () {
  var copyCache = null;
  var tooltipIndex = 0;
  var lastToggleAt = 0;
  var activeTrigger = null;
  var mobileQuery = window.matchMedia("(max-width: 749px)");

  function getCopy() {
    if (copyCache) return copyCache;
    var node = document.querySelector("[data-pdp-selector-tooltip-copy]");
    if (!node) return null;
    try {
      copyCache = JSON.parse(node.textContent);
    } catch (e) {
      copyCache = null;
    }
    return copyCache;
  }

  function isMobile() {
    return mobileQuery.matches;
  }

  function escapeHtml(text) {
    return String(text == null ? "" : text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function formatInline(text) {
    return escapeHtml(String(text).replace(/&#(?:39|x27);|&apos;/gi, "'")).replace(
      /\*\*(.+?)\*\*/g,
      "<strong>$1</strong>"
    );
  }

  function splitValues(raw) {
    if (!raw) return [];
    return String(raw)
      .split("|")
      .map(function (value) {
        return value.trim();
      })
      .filter(Boolean);
  }

  function detectKind(metafield, label, productType) {
    var field = String(metafield || "").toLowerCase();
    var heading = String(label || "").toLowerCase();

    if (field.indexOf("heating_capacity") !== -1 || field.indexOf("btus") !== -1 || heading.indexOf("btu") !== -1) {
      return "btu";
    }
    if (field.indexOf("furnace_efficiency") !== -1 || field.indexOf("afue") !== -1) {
      return "afue";
    }
    if (field.indexOf("seer") !== -1 || heading.indexOf("seer") !== -1) {
      return "seer2";
    }
    if (heading.indexOf("efficiency") !== -1) {
      return productType === "furnace" ? "afue" : "seer2";
    }
    if (field.indexOf("tonnage") !== -1 || heading.indexOf("tonnage") !== -1) {
      return "tonnage";
    }
    if (
      field.indexOf("coil") !== -1 ||
      field.indexOf("width") !== -1 ||
      heading.indexOf("cabinet") !== -1 ||
      heading.indexOf("width") !== -1
    ) {
      return "cabinet";
    }
    if (field.indexOf("configuration") !== -1 || heading.indexOf("configuration") !== -1) {
      return "configuration";
    }
    if (field.indexOf("stage") !== -1 || heading.indexOf("stage") !== -1) {
      return "stages";
    }
    return "";
  }

  function matchStageKey(value) {
    var text = String(value || "").toLowerCase();
    if (/modulat/.test(text)) return "modulating";
    if (/variable/.test(text) && /two/.test(text)) return "two_variable";
    if (/variable/.test(text)) return "variable";
    if (/two/.test(text) || /2\s*stage/.test(text)) return "two";
    if (/single/.test(text)) return "single";
    return "";
  }

  function pickConfigKey(values, productType) {
    var hasUpflow = values.some(function (value) {
      return /upflow/i.test(value);
    });
    var hasDownflow = values.some(function (value) {
      return /downflow/i.test(value);
    });
    var hasMulti = values.some(function (value) {
      return /multi/i.test(value);
    });
    var hasVertical = values.some(function (value) {
      return /^vertical$/i.test(String(value).trim());
    });

    if (hasUpflow || hasDownflow) return "upflow_downflow";
    if (productType === "air_handler" && hasMulti) return "multi_air_handler";
    if (hasMulti && hasVertical) return "multi_vertical";
    if (hasMulti && productType === "furnace") return "multi_furnace";
    if (hasMulti && (productType === "ac_coil" || productType === "generic")) return "multi_vertical";
    if (hasMulti) return "multi_furnace";
    return "horizontal_vertical";
  }

  function resolveContent(kind, productType, values, copy) {
    if (!copy || !kind) return null;

    if (kind === "tonnage") {
      if (productType === "air_handler") {
        return { title: copy.tonnage_air_handler_title, body: formatInline(copy.tonnage_air_handler_body) };
      }
      return { title: copy.tonnage_system_title, body: formatInline(copy.tonnage_system_body) };
    }

    if (kind === "seer2") {
      return { title: copy.seer2_title, body: formatInline(copy.seer2_body) };
    }

    if (kind === "btu") {
      return { title: copy.btu_title, body: formatInline(copy.btu_body) };
    }

    if (kind === "afue") {
      return { title: copy.afue_title, body: formatInline(copy.afue_body) };
    }

    if (kind === "cabinet") {
      if (productType === "air_handler") {
        return { title: copy.cabinet_air_handler_title, body: formatInline(copy.cabinet_air_handler_body) };
      }
      return { title: copy.cabinet_system_title, body: formatInline(copy.cabinet_system_body) };
    }

    if (kind === "configuration") {
      var configKey = pickConfigKey(values, productType);
      return {
        title: copy["config_" + configKey + "_title"],
        body: formatInline(copy["config_" + configKey + "_body"]),
      };
    }

    if (kind === "stages") {
      var keys = values
        .map(matchStageKey)
        .filter(function (key, index, list) {
          return key && list.indexOf(key) === index;
        });

      if (productType === "heat_pump") {
        var sentences = [];
        if (!keys.length || keys.indexOf("single") !== -1) sentences.push(formatInline(copy.stages_heat_pump_single));
        if (!keys.length || keys.indexOf("variable") !== -1) sentences.push(formatInline(copy.stages_heat_pump_variable));
        if (keys.indexOf("single") !== -1 || keys.indexOf("variable") !== -1 || !keys.length) {
          sentences.push(formatInline(copy.stages_heat_pump_footer));
        }
        if (!sentences.length) return null;
        return { title: copy.stages_heat_pump_title, body: sentences.join(" ") };
      }

      var lines = [];
      var hasModulating = keys.indexOf("modulating") !== -1;
      if (!keys.length || keys.indexOf("single") !== -1) lines.push(formatInline(copy.stages_furnace_single));
      if (!keys.length || keys.indexOf("two") !== -1) lines.push(formatInline(copy.stages_furnace_two));
      if (!keys.length || keys.indexOf("two_variable") !== -1) {
        lines.push(formatInline(hasModulating ? copy.stages_furnace_two_variable_short : copy.stages_furnace_two_variable));
      }
      if (hasModulating) lines.push(formatInline(copy.stages_furnace_modulating));
      if (!lines.length) return null;
      return {
        title: copy.stages_furnace_title,
        body: lines
          .map(function (line) {
            return '<span class="pdp-selector-tooltip__line">' + line + "</span>";
          })
          .join(""),
      };
    }

    return null;
  }

  function getSheet() {
    return document.querySelector(".pdp-selector-tooltip-sheet");
  }

  function ensureSheet(copy) {
    var existing = getSheet();
    if (existing) return existing;

    var root = document.createElement("div");
    root.className = "pdp-selector-tooltip-sheet";
    root.innerHTML =
      '<div class="pdp-selector-tooltip-sheet__overlay" data-sheet-close="true">&nbsp;</div>' +
      '<div class="pdp-selector-tooltip-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="pdp-selector-tooltip-sheet-title">' +
      '<div class="pdp-selector-tooltip-sheet__handle" aria-hidden="true">' +
      '<span class="pdp-selector-tooltip-sheet__grabber">&nbsp;</span>' +
      "</div>" +
      '<div class="pdp-selector-tooltip-sheet__content">' +
      '<h2 class="pdp-selector-tooltip-sheet__title" id="pdp-selector-tooltip-sheet-title"></h2>' +
      '<div class="pdp-selector-tooltip-sheet__body"></div>' +
      '<button type="button" class="pdp-selector-tooltip-sheet__got-it" data-sheet-close="true"></button>' +
      "</div></div>";

    var gotIt = root.querySelector(".pdp-selector-tooltip-sheet__got-it");
    if (gotIt) gotIt.textContent = copy.got_it || "Got it";

    var overlay = root.querySelector(".pdp-selector-tooltip-sheet__overlay");
    if (overlay) {
      overlay.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeAll();
      });
    }

    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-sheet-close]")) {
        event.preventDefault();
        event.stopPropagation();
        closeAll();
      }
    });

    bindSheetDrag(root);
    document.body.appendChild(root);
    return root;
  }

  function bindSheetDrag(root) {
    var panel = root.querySelector(".pdp-selector-tooltip-sheet__panel");
    var handle = root.querySelector(".pdp-selector-tooltip-sheet__handle");
    if (!panel || !handle) return;

    var startY = 0;
    var offsetY = 0;
    var dragging = false;
    var startOnHandle = false;

    function resetPanel() {
      panel.style.transition = "";
      panel.style.transform = "";
      root.classList.remove("is-dragging");
    }

    function onStart(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      if (event.target.closest(".pdp-selector-tooltip-sheet__got-it")) return;
      dragging = true;
      startY = event.clientY;
      offsetY = 0;
      startOnHandle = !!event.target.closest(".pdp-selector-tooltip-sheet__handle");
      panel.style.transition = "none";
      root.classList.add("is-dragging");
      if (panel.setPointerCapture) panel.setPointerCapture(event.pointerId);
    }

    function onMove(event) {
      if (!dragging) return;
      offsetY = Math.max(0, event.clientY - startY);
      panel.style.transform = "translateY(" + offsetY + "px)";
      if (event.cancelable) event.preventDefault();
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      if (offsetY > 72) {
        resetPanel();
        closeAll();
        return;
      }
      if (offsetY < 8 && startOnHandle) {
        resetPanel();
        closeAll();
        return;
      }
      resetPanel();
    }

    panel.addEventListener("pointerdown", onStart);
    panel.addEventListener("pointermove", onMove);
    panel.addEventListener("pointerup", onEnd);
    panel.addEventListener("pointercancel", onEnd);
  }

  function getPanel(tooltip) {
    var button = tooltip.querySelector(".pdp-selector-tooltip__button");
    var id = button && button.getAttribute("aria-controls");
    return (id && document.getElementById(id)) || tooltip.querySelector(".pdp-selector-tooltip__panel");
  }

  function restorePanel(tooltip) {
    var panel = getPanel(tooltip);
    if (!panel) return;
    panel.classList.remove("is-visible", "is-floated");
    panel.style.top = "";
    panel.style.left = "";
    panel.style.transform = "";
    if (panel.parentNode !== tooltip) tooltip.appendChild(panel);
  }

  function closeTooltip(tooltip) {
    if (!tooltip) return;
    tooltip.classList.remove("is-open");
    restorePanel(tooltip);
    var button = tooltip.querySelector(".pdp-selector-tooltip__button");
    if (button) button.setAttribute("aria-expanded", "false");
  }

  function closeSheet() {
    var sheet = getSheet();
    if (sheet) {
      var panel = sheet.querySelector(".pdp-selector-tooltip-sheet__panel");
      if (panel) panel.style.transform = "";
      sheet.classList.remove("is-open");
    }
    document.body.classList.remove("pdp-selector-tooltip-open");
  }

  function closeAll() {
    document.querySelectorAll(".pdp-selector-tooltip").forEach(closeTooltip);
    closeSheet();
    if (activeTrigger) {
      activeTrigger.focus();
      activeTrigger = null;
    }
  }

  function positionPanel(tooltip) {
    if (isMobile()) return;
    var panel = getPanel(tooltip);
    var button = tooltip.querySelector(".pdp-selector-tooltip__button");
    if (!panel || !button) return;

    var br = button.getBoundingClientRect();
    panel.style.top = br.bottom + 8 + "px";
    panel.style.left = br.left + br.width / 2 + "px";
    panel.style.transform = "translateX(-50%)";
    panel.style.setProperty("--pdp-tooltip-beak", "50%");

    var rect = panel.getBoundingClientRect();
    var pad = 8;
    var shift = 0;
    if (rect.left < pad) shift = pad - rect.left;
    else if (rect.right > window.innerWidth - pad) shift = window.innerWidth - pad - rect.right;

    if (shift) {
      panel.style.transform = "translateX(calc(-50% + " + shift + "px))";
      panel.style.setProperty("--pdp-tooltip-beak", "calc(50% - " + shift + "px)");
    }
  }

  function showDesktopPanel(tooltip) {
    if (isMobile()) return;
    document.querySelectorAll(".pdp-selector-tooltip").forEach(function (other) {
      if (other !== tooltip) closeTooltip(other);
    });
    closeSheet();

    var panel = getPanel(tooltip);
    var button = tooltip.querySelector(".pdp-selector-tooltip__button");
    if (!panel || !button) return;

    document.body.appendChild(panel);
    panel.classList.add("is-floated", "is-visible");
    if (button) button.setAttribute("aria-expanded", "true");
    positionPanel(tooltip);
  }

  function openDesktop(tooltip) {
    showDesktopPanel(tooltip);
    tooltip.classList.add("is-open");
  }

  function openMobile(tooltip, copy) {
    document.querySelectorAll(".pdp-selector-tooltip.is-open").forEach(closeTooltip);
    var sheet = ensureSheet(copy);
    var title = tooltip.querySelector(".pdp-selector-tooltip__title");
    var body = tooltip.querySelector(".pdp-selector-tooltip__body");
    var sheetTitle = sheet.querySelector(".pdp-selector-tooltip-sheet__title");
    var sheetBody = sheet.querySelector(".pdp-selector-tooltip-sheet__body");
    if (sheetTitle) sheetTitle.textContent = title ? title.textContent : "";
    if (sheetBody) sheetBody.innerHTML = body ? body.innerHTML : "";

    var button = tooltip.querySelector(".pdp-selector-tooltip__button");
    if (button) button.setAttribute("aria-expanded", "true");
    activeTrigger = button;
    sheet.classList.add("is-open");
    document.body.classList.add("pdp-selector-tooltip-open");

    var gotIt = sheet.querySelector(".pdp-selector-tooltip-sheet__got-it");
    if (gotIt) gotIt.focus();
  }

  function toggleTooltip(tooltip) {
    var copy = getCopy();
    lastToggleAt = Date.now();

    if (isMobile()) {
      var sheet = getSheet();
      var sheetOpen = sheet && sheet.classList.contains("is-open");
      var sameTrigger = activeTrigger && tooltip.contains(activeTrigger);
      if (sheetOpen && sameTrigger) {
        closeAll();
        return;
      }
      openMobile(tooltip, copy);
      return;
    }

    if (tooltip.classList.contains("is-open")) closeTooltip(tooltip);
    else openDesktop(tooltip);
  }

  function bindTooltip(tooltip) {
    if (tooltip.dataset.bound === "true") return;
    tooltip.dataset.bound = "true";

    var button = tooltip.querySelector(".pdp-selector-tooltip__button");
    var panel = tooltip.querySelector(".pdp-selector-tooltip__panel");
    if (!button || !panel) return;
    var hideTimer = null;

    function cancelHide() {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
    }

    function scheduleHide() {
      if (tooltip.classList.contains("is-open")) return;
      cancelHide();
      hideTimer = setTimeout(function () {
        if (!tooltip.classList.contains("is-open")) closeTooltip(tooltip);
      }, 120);
    }

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      toggleTooltip(tooltip);
    });

    tooltip.addEventListener("mouseenter", function () {
      if (isMobile()) return;
      cancelHide();
      showDesktopPanel(tooltip);
    });

    tooltip.addEventListener("mouseleave", function () {
      if (isMobile()) return;
      scheduleHide();
    });

    panel.addEventListener("mouseenter", function () {
      if (isMobile()) return;
      cancelHide();
    });

    panel.addEventListener("mouseleave", function () {
      if (isMobile()) return;
      scheduleHide();
    });

    tooltip.addEventListener("focusin", function () {
      if (isMobile()) return;
      cancelHide();
      showDesktopPanel(tooltip);
    });

    tooltip.addEventListener("focusout", function (event) {
      if (isMobile()) return;
      if (tooltip.contains(event.relatedTarget) || panel.contains(event.relatedTarget)) return;
      scheduleHide();
    });
  }

  function createTooltip(heading, content, copy) {
    tooltipIndex += 1;
    var panelId = "pdp-selector-tooltip-" + tooltipIndex;
    var wrap = document.createElement("div");
    wrap.className = "pdp-selector-tooltip";

    var button = document.createElement("button");
    button.type = "button";
    button.className = "pdp-selector-tooltip__button";
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-controls", panelId);
    button.setAttribute(
      "aria-label",
      String(copy.toggle_label || "More information about {{ heading }}").replace("{{ heading }}", heading)
    );

    var icon = document.createElement("img");
    icon.src = copy.icon;
    icon.width = 20;
    icon.height = 20;
    icon.alt = "";
    icon.setAttribute("aria-hidden", "true");
    button.appendChild(icon);

    var panel = document.createElement("div");
    panel.className = "pdp-selector-tooltip__panel";
    panel.id = panelId;
    panel.setAttribute("role", "tooltip");
    panel.innerHTML =
      '<p class="pdp-selector-tooltip__title">' +
      escapeHtml(content.title) +
      '</p><div class="pdp-selector-tooltip__body">' +
      content.body +
      "</div>";

    wrap.appendChild(button);
    wrap.appendChild(panel);
    bindTooltip(wrap);
    return wrap;
  }

  function enhanceGroup(group, productType, copy) {
    if (!group || group.querySelector(".pdp-selector-tooltip")) return;

    var headingEl = group.querySelector(".custom-variant-selector__heading");
    var labelEl = group.querySelector(".custom-variant-selector__label");
    if (!headingEl || !labelEl) return;

    var metafield = group.getAttribute("data-metafield") || "";
    var values = splitValues(group.getAttribute("data-option-values"));
    if (!values.length) {
      group.querySelectorAll(".custom-variant-selector__option").forEach(function (option) {
        var value = (option.getAttribute("aria-label") || option.textContent || "").trim();
        if (value) values.push(value);
      });
    }

    var kind = detectKind(metafield, labelEl.textContent, productType);
    var content = resolveContent(kind, productType, values, copy);
    if (!content || !content.title || !content.body) return;

    headingEl.appendChild(createTooltip(labelEl.textContent.trim(), content, copy));
  }

  function initPdpSelectorTooltips(root) {
    var copy = getCopy();
    if (!copy) return;
    ensureSheet(copy);

    var scopes = [];
    if (root && root.classList && root.classList.contains("custom-variant-selector")) {
      scopes.push(root);
    } else {
      (root || document).querySelectorAll(".custom-variant-selector").forEach(function (node) {
        scopes.push(node);
      });
    }

    scopes.forEach(function (selector) {
      var productType = selector.getAttribute("data-product-type") || "generic";
      selector.querySelectorAll(".custom-variant-selector__group").forEach(function (group) {
        enhanceGroup(group, productType, copy);
      });
    });
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-sheet-close]")) {
      closeAll();
      return;
    }
    if (Date.now() - lastToggleAt < 400) return;
    if (event.target.closest(".pdp-selector-tooltip")) return;
    if (event.target.closest(".pdp-selector-tooltip__panel")) return;
    if (event.target.closest(".pdp-selector-tooltip-sheet__panel") && !event.target.closest("[data-sheet-close]")) {
      return;
    }
    if (event.target.closest(".pdp-selector-tooltip-sheet")) {
      closeAll();
      return;
    }
    closeAll();
  });

  window.addEventListener(
    "scroll",
    function () {
      document.querySelectorAll(".pdp-selector-tooltip").forEach(function (tooltip) {
        var panel = getPanel(tooltip);
        if (panel && panel.classList.contains("is-visible")) positionPanel(tooltip);
      });
    },
    true
  );

  window.addEventListener("resize", function () {
    document.querySelectorAll(".pdp-selector-tooltip").forEach(function (tooltip) {
      var panel = getPanel(tooltip);
      if (panel && panel.classList.contains("is-visible")) positionPanel(tooltip);
    });
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeAll();
  });

  function onBreakpointChange() {
    closeAll();
  }

  if (mobileQuery.addEventListener) mobileQuery.addEventListener("change", onBreakpointChange);
  else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpointChange);

  window.initPdpSelectorTooltips = initPdpSelectorTooltips;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initPdpSelectorTooltips();
    });
  } else {
    initPdpSelectorTooltips();
  }
})();
